module.exports = __webpack_public_path__ + "img/hest8.67c1210e.jpg";